import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n'], ['\n  display: block;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  ', ' border-radius: 2px;\n'], ['\n  background-color: ', ';\n  ', ' border-radius: 2px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ' ', ' &:focus {\n    outline-style: solid;\n    outline-color: ', ';\n    outline-width: 2px;\n  }\n'], ['\n  ', ' ', ' &:focus {\n    outline-style: solid;\n    outline-color: ', ';\n    outline-width: 2px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  ', ';\n'], ['\n  ', ';\n']);

import styled, { css } from 'styled-components';
import { akElevationMixins } from '@atlaskit/util-shared-styles';
import { colors } from '@atlaskit/theme';
import { TableBodyRow } from '../TableRow';

var rankingStyles = css(_templateObject);

var rankingItemStyles = css(_templateObject2, colors.N20, akElevationMixins.e500);

var draggableStyles = function draggableStyles(_ref) {
  var isRanking = _ref.isRanking,
      isRankingItem = _ref.isRankingItem;
  return css(_templateObject3, isRanking && rankingStyles, isRankingItem && rankingItemStyles, colors.B100);
};

export var RankableTableBodyRow = styled(TableBodyRow)(_templateObject4, draggableStyles);